import { render, staticRenderFns } from "./Step3-Type2-Content.vue?vue&type=template&id=f4117cf6&"
import script from "./Step3-Type2-Content.vue?vue&type=script&lang=js&"
export * from "./Step3-Type2-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports